import {ref} from 'vue'

export const isOpenDrawer = ref(false)